import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {RegionModel} from '../../../../models/RegionModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {FormControl} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import {DesignServicesModel} from '../../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {ProviderModel} from '../../../../models/ProviderModel';


@Component({
  selector: 'app-region-filter',
  templateUrl: './region-filter.component.html',
  styleUrls: ['./region-filter.component.scss']
})
export class RegionFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listRegionFilter: any[];
  optionSelected: any;
  formControl: FormControl = new FormControl();
  filteredOptions: BehaviorSubject<RegionModel[]> = new BehaviorSubject<RegionModel[]>([]);

  filterAllSettings: AllSettingsFilterModel;

  @Input() regionData: any;
  @Input() regionSelected: RegionModel;

  @Input() inAllSettings?: boolean;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() sizeForFilterInSettings?: SizeModel;
  @Input() siteForFilterInSettings?: SiteModel;

  @Input() numAnnoMeseFromForFilterInSettings: number;
  @Input() numAnnoMeseToForFilterInSettings: number;

  constructor(private regionService: RegionService) {
    super();
  }

  ngOnInit() {
    this.fetchFilterData();
    this.formControl.setValue(this.regionSelected ? this.regionSelected.cod : null);
    this.formControl.valueChanges
      .subscribe(value => {
        const result = this._filter(value);
        this.filteredOptions.next(result);
        this.dataFiltered.emit(this.filteredOptions.value.find(x => x.cod === value || x.description === value));
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('regionData' in changes) {
      this.listRegionFilter = this.regionData;
      this.optionSelected = null;
    }
    if (
      'providerForFilterInSettings' in changes ||
      'localCustomerForFilterInSettings' in changes ||
      'contractTypeForFilterInSettings' in changes ||
      'resourceUnitForFilterInSettings' in changes ||
      'sizeForFilterInSettings' in changes ||
      'siteForFilterInSettings' in changes
    ) {
      this.fetchFilterData();
    }
    if (this.regionSelected || 'regionSelected' in changes) {
      this.optionSelected = this.regionSelected ? this.regionSelected.cod : null;
    }
    this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
  }

  fetchFilterData() {
    if (this.inAllSettings) {
      this.filterAllSettings = new AllSettingsFilterModel(
        this.regionSelected,
        this.localCustomerForFilterInSettings,
        this.resourceUnitForFilterInSettings,
        this.providerForFilterInSettings,
        this.contractTypeForFilterInSettings,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.sizeForFilterInSettings?.cod ? this.sizeForFilterInSettings : null,
        this.siteForFilterInSettings,
        null,
        null,
        null,
        null
      );
      this.regionService.getListInAllSettings(
        this.regionService.baseUrl,
        this.filterAllSettings)
        .subscribe(
          (result: any) => {
            this.listRegionFilter = this.regionData = result;
            // this.optionSelected = null;
            this.filteredOptions.next(this._filter(this.optionSelected ? this.optionSelected.cod : ''));
          });
    }
  }

  private _filter(value: string): RegionModel[] {
    const filterValue = value ? value.toLowerCase() : '';
    if (!this.regionData) {
      return [];
    }
    return this.regionData.filter(
      option => option.cod.toLowerCase().includes(filterValue) || option.description.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
  }

}
